import PropTypes from "prop-types";
import React, { useContext } from "react";
import heartFilledSrc from "../../../../assets/icons/heart-filled@3x.png";
import ANSWERS from "../../../../constants/answers";
import { I18nContext } from "../../../../providers/i18n";
import "./styles.scss";
import Subtitle from "./Subtitle";

const ANSWER_DISPLAY_STRATEGY = {
  [ANSWERS.YES]: {
    getClassName: isInverted => (!isInverted ? "text-yes" : "text-no"),
    translationKey: "yes"
  },
  [ANSWERS.NO]: {
    getClassName: isInverted => (!isInverted ? "text-no" : "text-yes"),
    translationKey: "no"
  },
  [ANSWERS.SKIP]: { getClassName: () => "text-skip", translationKey: "—" },
  default: { getClassName: () => "", translationKey: "" }
};

const QuestionsOverview = props => {
  const { t } = useContext(I18nContext);
  const { questions, containerClassName } = props;
  const handleQuestionClick = id => () => {
    return this.props.onQuestionClick && this.props.onQuestionClick(id);
  };

  return (
    <div className={`QuestionsOverview ${containerClassName}`}>
      <Subtitle
        className={"mb16"}
        text={t("vote.results.detailedAnswersArchive")}
      />
      <div className={"questions-container"}>
        {questions.map(it => {
          const questionDisplay =
            ANSWER_DISPLAY_STRATEGY[it.answer] ||
            ANSWER_DISPLAY_STRATEGY.default ||
            "";
          return (
            <div className={"question"} key={it.id}>
              {it.isLiked ? (
                <img className={"heart"} src={heartFilledSrc} alt={"heart"} />
              ) : (
                <div className={"heart"} />
              )}
              <span
                onClick={handleQuestionClick(it.id)}
                className={`text ${questionDisplay.getClassName(
                  it.invertsAnswer
                )}`}
              >
                {it.text}
              </span>
              <span onClick={handleQuestionClick(it.id)} className={`answer`}>
                {t(questionDisplay.translationKey)}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
QuestionsOverview.defaultProps = {
  containerClassName: "",
  onQuestionClick: () => {}
};

QuestionsOverview.propTypes = {
  containerClassName: PropTypes.string,
  onQuestionClick: PropTypes.func,
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.any,
      text: PropTypes.string,
      answer: PropTypes.string,
      isLiked: PropTypes.bool
    })
  ).isRequired
};

export default QuestionsOverview;
